import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import React, { useEffect } from 'react';
import { FC, ReactNode } from 'react';

import { subscribeAuthSuccess } from 'APP/packages/bus/adapters/auth/auth';
import Entities from 'STORE';

interface IBugsnagWrapperProps {
  children: ReactNode;
}

export const BugsnagWrapper: FC<IBugsnagWrapperProps> = (props) => {
  const bugsnagClient = Bugsnag.start({
    apiKey: 'YOUR_API_KEY',
    plugins: [new BugsnagPluginReact()],
    appVersion: Entities.App.version,
  });

  useEffect(() => {
    subscribeAuthSuccess((id: string): void => {
      Bugsnag.setUser(id);
    });
  }, []);

  const ErrorBoundary = bugsnagClient.getPlugin('react')?.createErrorBoundary(React);

  return ErrorBoundary ? <ErrorBoundary>{props.children}</ErrorBoundary> : <>props.children</>;
};
